import {
  Button,
  Divider,
  Typography,
  Box,
  Container,
  List,
  ListSubheader,
  ListItem,
  ListItemText
} from '@mui/material';
import { blue, grey } from '@mui/material/colors';
import { useActiveStep } from '../hooks/useActiveStep';

const hospitals: {
  name: string;
  phoneNumber: string;
}[] = [
  {
    name: '足と歩行のクリニック荻窪院',
    phoneNumber: '03-6383-5685'
  },
  {
    name: '足と歩行の診療所(蒲田)',
    phoneNumber: '03-6715-9430'
  }
];

export function IntroductionOtherHospital() {
  const { setActiveStep } = useActiveStep();
  return (
    <Container maxWidth="md">
      <Box sx={{ p: 2 }}>
        <Typography variant="h5" gutterBottom sx={{ color: grey[600] }}>
          他院紹介
        </Typography>
        <Divider />
        <Typography sx={{ mt: 3 }}>
          当院では、フルDXクリニックとして完全なオンラインによる問診と予約、院内誘導を行なっています。
          <br />
          そのため診療方針や、データの取り扱い等の包括同意にご同意いただけないお客様には、系列病院での受診をお願いしております。
          <br />
          何卒ご了承いただけますようよろしくお願い申し上げます。
        </Typography>
        <List
          sx={{ width: '100%' }}
          component="nav"
          subheader={
            <ListSubheader component="div" color="inherit" sx={{ fontSize: 25, mt: 5, mb: 3 }}>
              系列病院
            </ListSubheader>
          }
        >
          {hospitals.map((hospital) => (
            <ListItem key={hospital.name} disableGutters sx={{ mb: 3 }}>
              <ListItemText primary={hospital.name} primaryTypographyProps={{ fontSize: 20, color: blue[700] }} />
              <ListItemText
                primary={hospital.phoneNumber}
                primaryTypographyProps={{ fontSize: 20, textAlign: 'end', color: blue[700] }}
              />
            </ListItem>
          ))}
        </List>
        <Box>
          <Button
            variant="contained"
            onClick={() => {
              setActiveStep('ComprehensiveConsent');
            }}
            sx={{ width: '20%' }}
          >
            戻る
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
